import { useMemo } from "react";

import { Crop } from "../models/crops";
import { StateEnveloped } from "../redux/helpers";
import { makeHookDeprecationWarn } from "../helpers/warnings";
import { useCropsData } from "../next/hooks";
import {
  useCropsGlobalActivity,
  useCropsGlobalStatus,
} from "../next/hooks/crops";

type Data = { crops: Crop[]; cropsById: Record<string, Crop | undefined> };
export type CropsHookResult = StateEnveloped<Data>;
export type CropsHook = () => CropsHookResult;

const deprecationWarn = makeHookDeprecationWarn("useCrops");

/**
 * @deprecated Use next.hooks.useCrops instead.
 */
const Hook: CropsHook = () => {
  deprecationWarn();

  const data = useCropsData();
  const status = useCropsGlobalStatus();
  const activity = useCropsGlobalActivity();

  const memoizedResult = useMemo(
    () => ({
      status,
      activity,
      data,
    }),
    [status, activity, data],
  );

  return memoizedResult;
};

export default Hook;
